export interface AccredibleLanguage {
  code: string;
  name: string;
  matLib: unknown;
}
